/**
 * TARO Shell · 论坛端入口
 *
 * 三栏工作台：左导航 | 中内容 | 右 Agent 对话面板
 * 实际的 DOM 重排由 shell/WorkSpaceShell 在 Flarum 挂载完成后执行。
 *
 * 强制登录：未登录访问任何页面 → 跳转 /login（自定义登录页）
 *
 * 注意：本文件仅在 forum 前端加载，admin 后台不受影响。
 */

import app from 'flarum/forum/app';
import { initShell } from './shell/initShell';
import LoginPage from './components/LoginPage';

app.initializers.add('taro/shell', () => {

  // ---------- 自定义登录页路由 ----------
  app.routes.login = { path: '/login', component: LoginPage };

  // ---------- 强制登录 ----------
  // app.session 在 Flarum boot 内部创建（initializers 执行时可能尚未就绪），
  // guest 判断必须等 boot 完成，否则已登录用户会被误弹 /login。
  const isGuest = () => !(app.session && app.session.user);
  const onLoginPage = () => {
    const p = (m.route.get && m.route.get()) || window.location.pathname || '/';
    return p === '/login' || p.indexOf('/login') === 0;
  };
  // 用轮询等 session 就绪（最长 3s），就绪前不做任何重定向/拦截
  const whenSessionReady = (cb, attempt = 0) => {
    if (app.session && app.session.csrfToken) {
      cb();
    } else if (attempt < 30) {
      setTimeout(() => whenSessionReady(cb, attempt + 1), 100);
    }
  };

  whenSessionReady(() => {
    if (isGuest()) {
      const redirect = () => {
        if (!onLoginPage()) {
          m.route.set('/login');
        }
      };
      redirect();
      setTimeout(redirect, 300);

      // 拦截 SPA 内部导航
      if (!m.route.__taroLoginPatched) {
        m.route.__taroLoginPatched = true;
        const originalSet = m.route.set.bind(m.route);
        m.route.set = function (path, ...args) {
          if (isGuest()) {
            const target = typeof path === 'string' ? path : '';
            if (target.indexOf('/login') !== 0) {
              return originalSet('/login', ...args);
            }
          }
          return originalSet(path, ...args);
        };
      }
    } else {
      // ---------- 已登录：登录落地跳转 ----------
      let dest = null;
      try {
        dest = sessionStorage.getItem('taro-login-dest');
        if (dest) sessionStorage.removeItem('taro-login-dest');
      } catch (_) {}
      if (dest) {
        const tryNavigate = (attempt) => {
          if (m.route.get && m.route.get() !== undefined) {
            m.route.set(dest);
          } else if (attempt < 30) {
            setTimeout(() => tryNavigate(attempt + 1), 100);
          }
        };
        setTimeout(() => tryNavigate(0), 100);
      }
    }
  });

  // ---------- 三栏工作台 ----------
  // initializers 在 m.mount 之前执行；
  // 外壳需要等 Flarum 把 #content 渲染出来之后再做 reparent，
  // 所以推迟到下一个宏任务（mount 渲染是同步的，setTimeout 0 足够）。
  setTimeout(() => {
    try {
      if (isGuest()) return; // guest 停留在登录页，不初始化工作台
      initShell();
    } catch (e) {
      console.warn('[taro/shell] init failed, fallback to default layout:', e);
    }
  }, 0);
});
